<button [style.width.px]="width" [ngClass]="{'no-valid': disabled, 'small': isSmall}" class='{{class}}'
    (click)="onClick()" [disabled]="disabled">
    <img *ngIf="icon" src="assets/{{ icon }}.svg" alt="icon">
    <span class="text">{{ text }}</span>
</button>